import { memo } from 'react';
import { SessionByDateDto } from '@repo/shared/dtos/my-insights/SessionByDateDto';
import { getSessionColor } from '../utils';

interface SessionItemProps {
  session: SessionByDateDto;
  index: number;
  isSelected: boolean;
  onSelect: (sessionId: string) => void;
}

export const SessionItem = memo(({ session, index, isSelected, onSelect }: SessionItemProps) => {
  const sessionColor = getSessionColor(index);

  return (
    <div
      onClick={() => onSelect(session.id)}
      className={`flex cursor-pointer items-center justify-between rounded-md p-2 text-sm transition-colors ${
        isSelected
          ? 'border border-indigo-100 bg-indigo-50'
          : 'border border-transparent hover:bg-gray-50'
      }`}
      role="listitem"
    >
      <div className="flex items-center">
        <div
          className="mr-3 h-3 w-3 rounded-full border border-gray-200"
          style={{ backgroundColor: sessionColor }}
          aria-hidden="true"
        />
        <span className="font-medium">{session.name}</span>
      </div>
      <span className="text-gray-500">
        {new Date(session.startTime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
      </span>
    </div>
  );
});
